import React, { useEffect, useState } from 'react'
import { Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getRelatedBlogs, getSingleBlog } from '../App/Slices/blogSlice';
import SixCardSlider from '../components/BlogSection/SixCardSlider';
import { toast } from 'react-toastify';
import {
    FacebookShareButton,
    WhatsappShareButton,
    LinkedinShareButton,
    FacebookIcon,
    WhatsappIcon,
    LinkedinIcon,
} from "react-share";
import { Helmet } from 'react-helmet-async';


const BlogDetails = () => {
    const url = window.location.href;

    const baseUrl = process.env.REACT_APP_BASE_URL;
    const { relatedblogs } = useSelector((state) => state.blogsData);
    const dispatch = useDispatch()
    const { singleblog } = useSelector((state) => state.blogsData);
    const { slug } = useParams();
    useEffect(() => {
        dispatch(getSingleBlog(slug))
    }, [dispatch, slug])


    // ✅ After single blog is available, fetch related blogs
    useEffect(() => {
        if (singleblog?.id) {
            try {
                dispatch(
                    getRelatedBlogs({
                        blogId: singleblog.id, // pass id
                    })
                );
            } catch (err) {
                console.error("Error fetching related blogs:", err.message);
                toast.error("Failed to fetch related blogs.");
            }
        }
    }, [dispatch, singleblog]);
    const shareHashtag = `#${singleblog?.title
        }\n\n#${singleblog?.title}\n\n#${singleblog?.slug}\n\n#PanavBiotech`;
    const shareHashtag_fb = `#PanavBiotech #${singleblog?.title
        } `;
    const shareMessage = `${singleblog?.title}\n\n${singleblog?.description}\n\n`;

    return (
        <>
            {/* Helmet for SEO */}
            <Helmet>
                <title>{singleblog?.meta_title}</title>
                <meta name="description" content={singleblog?.meta_description} />
                <meta property="og:title" content={singleblog?.meta_title} />
                <meta property="og:description" content={singleblog?.meta_description} />
                <meta property="og:image" content={singleblog?.image} />
            </Helmet>
            <Container fluid className='p-0'>
                <img src={`${baseUrl}/${singleblog?.banner_image}`} alt={singleblog?.banneralt} className='img-fluid w-100' />
                <div className='blue-bg-blog-details'>
                    <h1 className='text-white'>{singleblog?.title}</h1>
                </div>
                <Container className='text-center container-p-details-blogs'>
                    <Row className='mt-5 justify-content-center'>
                        <div className="col-md-10 col-sm-10 col-10">
                            <p dangerouslySetInnerHTML={{ __html: singleblog?.description }} />

                        </div>
                    </Row>
                </Container>
                <hr />
            </Container>



            {singleblog?.sub_image1 &&
                <Container className='blog-details-content-text-blog-details'>
                    <Row className="mt-5">
                        <div className="col-md-6  col-sm-12 col-12">
                            <div dangerouslySetInnerHTML={{ __html: singleblog?.subdes1 }} />

                        </div>
                        <div className="col-md-6  col-sm-12 col-12">
                            {/* img here  */}
                            <img src={`${baseUrl}/${singleblog?.sub_image1}`} alt={singleblog?.imagealt1} />
                        </div>
                    </Row>
                </Container>
            }
            {
                singleblog?.sub_image2 &&
                <Container className='blog-details-content-text-blog-details'>
                    <Row className="mt-5">
                        <div className="col-md-6  col-sm-12 col-12">
                            {/* img here  */}
                            <img src={`${baseUrl}/${singleblog?.sub_image2}`} alt={singleblog?.imagealt2} loading='lazy' />
                        </div>
                        <div className="col-md-6  col-sm-12 col-12">
                            <div dangerouslySetInnerHTML={{ __html: singleblog?.subdes2 }} />

                        </div>

                    </Row>
                </Container>
            }
            {singleblog?.sub_image3 &&
                <Container className='blog-details-content-text-blog-details'>
                    <Row className="mt-5">
                        <div className="col-md-6  col-sm-12 col-12">

                            <div dangerouslySetInnerHTML={{ __html: singleblog?.subdes3 }} />

                        </div>
                        <div className="col-md-6  col-sm-12 col-12">
                            {/* img here  */}
                            <img src={`${baseUrl}/${singleblog?.sub_image3}`} alt={singleblog?.imagealt3} loading='lazy' />

                        </div>
                    </Row>
                </Container>
            }
            {singleblog?.sub_image4 &&
                <Container className='blog-details-content-text-blog-details'>
                    <Row className="mt-5">
                        <div className="col-md-6  col-sm-12 col-12">
                            {/* img here  */}
                            <img src={`${baseUrl}/${singleblog?.sub_image4}`} alt={singleblog?.imagealt4} loading='lazy' />
                        </div>
                        <div className="col-md-6  col-sm-12 col-12">
                            <div dangerouslySetInnerHTML={{ __html: singleblog?.subdes4 }} />

                        </div>

                    </Row>
                </Container>
            }

            {/* 3333333333 */}
            {singleblog?.sub_image5 &&
                <Container className='blog-details-content-text-blog-details'>
                    <Row className="mt-5">
                        <div className="col-md-6  col-sm-12 col-12">

                            <div dangerouslySetInnerHTML={{ __html: singleblog?.subdes5 }} />

                        </div>
                        <div className="col-md-6  col-sm-12 col-12">
                            {/* img here  */}
                            <img src={`${baseUrl}/${singleblog?.sub_image5}`} alt={singleblog?.imagealt5} loading='lazy' />

                        </div>
                    </Row>
                </Container>
            }
            {singleblog?.sub_image6 &&
                <Container className='blog-details-content-text-blog-details'>
                    <Row className="mt-5">
                        <div className="col-md-6  col-sm-12 col-12">
                            {/* img here  */}
                            <img src={`${baseUrl}/${singleblog?.sub_image6}`} alt={singleblog?.imagealt6} loading='lazy' />
                        </div>
                        <div className="col-md-6  col-sm-12 col-12">
                            <div dangerouslySetInnerHTML={{ __html: singleblog?.subdes6 }} />

                        </div>

                    </Row>
                </Container>
            }
            {/* 3333333333 */}
            {singleblog?.sub_image7 &&
                <Container className='blog-details-content-text-blog-details'>
                    <Row className="mt-5">
                        <div className="col-md-6  col-sm-12 col-12">

                            <div dangerouslySetInnerHTML={{ __html: singleblog?.subdes7 }} />

                        </div>
                        <div className="col-md-6  col-sm-12 col-12">
                            {/* img here  */}
                            <img src={`${baseUrl}/${singleblog?.sub_image7}`} alt={singleblog?.imagealt7} loading='lazy' />

                        </div>
                    </Row>
                </Container>
            }
            {singleblog?.sub_image8 &&
                <Container className='blog-details-content-text-blog-details'>
                    <Row className="mt-5">
                        <div className="col-md-6  col-sm-12 col-12">
                            {/* img here  */}
                            <img src={`${baseUrl}/${singleblog?.sub_image8}`} alt={singleblog?.imagealt8} loading='lazy' />
                        </div>
                        <div className="col-md-6  col-sm-12 col-12">
                            <div dangerouslySetInnerHTML={{ __html: singleblog?.subdes8 }} />

                        </div>

                    </Row>
                </Container>
            }
            {singleblog?.sub_image9 &&
                <Container className='blog-details-content-text-blog-details'>
                    <Row className="mt-5">
                        <div className="col-md-6  col-sm-12 col-12">

                            <div dangerouslySetInnerHTML={{ __html: singleblog?.subdes9 }} />

                        </div>
                        <div className="col-md-6  col-sm-12 col-12">
                            {/* img here  */}
                            <img src={`${baseUrl}/${singleblog?.sub_image9}`} alt={singleblog?.imagealt9} loading='lazy' />

                        </div>
                    </Row>
                </Container>
            }
            {singleblog?.sub_image10 &&
                <Container className='blog-details-content-text-blog-details'>
                    <Row className="mt-5">
                        <div className="col-md-6  col-sm-12 col-12">
                            {/* img here  */}
                            <img src={`${baseUrl}/${singleblog?.sub_image10}`} alt={singleblog?.imagealt10} loading='lazy' />
                        </div>
                        <div className="col-md-6  col-sm-12 col-12">
                            <div dangerouslySetInnerHTML={{ __html: singleblog?.subdes10 }} />

                        </div>

                    </Row>
                </Container>
            }
            <section className='py-5'>
                <SixCardSlider blogs={relatedblogs} heading={'You May Also Like '} />
            </section>
            <div className="d-flex justify-content-center gap-3 mt-4">
                {/* Facebook */}

                <FacebookShareButton
                    url={url}
                    imageURL={singleblog?.image}
                    hashtag={shareHashtag_fb}
                    quote={shareMessage}
                >
                    <FacebookIcon size={40} round={true} />
                </FacebookShareButton>



                <WhatsappShareButton
                    title={shareMessage}
                    url={url}
                    hashtag={shareHashtag}
                >
                    <WhatsappIcon size={40} round={true} />
                </WhatsappShareButton>
                {/* LinkedIn */}
                <LinkedinShareButton url={`${window.location.origin}/blog-details/${slug}`} title={singleblog?.title}>
                    <LinkedinIcon size={40} round />
                </LinkedinShareButton>

            </div>
        </>
    )
}

export default BlogDetails
